export enum StepperAssignmentURLSteps {
  IDLE = 'welcome',
  EMERGENCY_CONTACT = 'emergency',
  PERSONAL_CONTACT = 'personal',
  BENEFICIARY_CONTACT = 'beneficiary',
  POLICIES = 'policies',
  FINANCE = 'financial',
  CUSTOMS = 'customs',
  VACCINATION = 'covid-vax-info',
  SOEA = 'soea',
}
